import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  inject,
  afterRenderEffect,
} from '@angular/core';
import { KingService } from '../king.service';
import { KingUser } from '../interfaces/king.interface';
import { KingWeaponComponent } from '../king-weapon/king-weapon.component';
import { KingHpBarComponent } from '../king-hp-bar/king-hp-bar.component';
import { ModalService } from '@features/modals/services/modal.service';
import { GameIconComponent } from '../../../core/components/game-icon/game-icon.component';
import { SvgIconComponent } from 'angular-svg-icon';
import { KingUserAvatarComponent } from '../../../features/king/king-user-avatar/king-user-avatar.component';
import { sleep } from '@core/utils/sleep.util';
import { fadeInAnimation } from '@core/utils/animations.util';

@Component({
  selector: 'app-king-side-top',
  templateUrl: './king-side-top.component.html',
  styleUrls: ['./king-side-top.component.scss'],
  standalone: true,
  imports: [
    KingWeaponComponent,
    KingHpBarComponent,
    GameIconComponent,
    SvgIconComponent,
    KingUserAvatarComponent,
  ],
  animations: [fadeInAnimation],
  host: {
    '[class.king]': '!isChallenger()',
    '[class.challenger]': 'isChallenger()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KingSideTopComponent {
  readonly isChallenger = input<boolean>(false);
  readonly user = input<KingUser | null>(null);
  attackAnimation = signal<string | null>(null);

  private readonly modalService = inject(ModalService);
  private readonly kingService = inject(KingService);

  private attackAnimationEffect = afterRenderEffect(async () => {
    const { hits, GUN_ANIMATION_DURATION } = this.kingService;
    const lastHit = hits().at(-1);
    if (
      lastHit &&
      lastHit.by === (this.isChallenger() ? 'challenger' : 'king')
    ) {
      this.attackAnimation.set(lastHit.animation);
      await sleep(GUN_ANIMATION_DURATION);
      this.attackAnimation.set(null);
    }
  });

  openDepositModal() {
    this.modalService.openModal('DepositKingModal');
  }
}
